import ActionCheckbox from 'components/ActionCheckBox';
import SearchBar from 'components/Autosuggest/Autosuggest';
import DropDown from 'components/FormFields/dropdown';
import InventoryItemUnitDropwdown from 'components/InventoryItemUnitDropdown';
import WholeNumberInput from 'components/WholeNumberInput';
import React, { useState } from 'react';
import { addInventoryItemToRecipe, searchItems } from 'services';
import { CUTTING_TYPE, showError, showSuccess } from 'utils';
import styles from './index.module.scss';

const AddInventoryItemToRecipe = props => {
  const [item, setItem] = useState<Record<string, any>>({});
  const [itemId, setItemId] = useState<string>('');
  const [recipeUnit, setRecipeUnit] = useState<string>('');
  const [recipeQuantity, setRecipeQuantity] = useState<string>('0');
  const [produceQuantity, setProduceQuantity] = useState<string>('0');
  const [cuttingType, setCuttingType] = useState<string>('');
  const [isMainIngredient, setIsMainIngredient] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const { recipeId, toggleModal,
    onSuccess } = props;

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    try {
      await addInventoryItemToRecipe({
        inventoryItemId: itemId,
        recipeId,
        recipeUnit,
        produceQuantity,
        recipeQuantity,
        cuttingType,
        isMainIngredient,
      });
      onSuccess();
      showSuccess('Recipe Inventory item added successfully');
      toggleModal();
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  const handleSuggestionClick = (suggestion: Record<string, any>) => {
    const item: Record<string, any> = {};
    item.id = suggestion.id;
    item.name = suggestion.displayName;
    setItem(item);
    setItemId(item.id);
  };

  const getFooter = () => {
    return (
      <div className={styles['modal-footer']}>
        <button
          className={styles['cancel-button']}
          type={'button'}
          disabled={loading}
          onClick={toggleModal}
        >
          Cancel
        </button>
        <button
          className={styles['submit-button']}
          type={'submit'}
          disabled={loading}
        >
          Submit
        </button>
      </div>
    );
  };

  const getHeader = () => {
    return (
      <div className={styles['modal-header']}>
        <div>
          <div className={styles['label']}>Recipe Inventory Item</div>
          <div className={styles['modal-title']}>Add Inventory Item</div>
        </div>
        <i className={'fa fa-times'} onClick={toggleModal} />
      </div>
    );
  };
  
  const getBody = () => {
    return (
      <div className={styles['modal-body']}>
        <div className={'mb-3'}>
          <div className={styles['label']}>InventoryItem</div>
          <SearchBar
            value={item.name || ''}
            setValue={value => setItem({ ...item, name: value })}
            searchAPI={searchItems}
            searchAPIParamKey={'term'}
            onSuggestionClicked={handleSuggestionClick}
          />
        </div>
        <div>
          <div className={styles['label']}>Recipe Unit</div>
          <InventoryItemUnitDropwdown
            value={recipeUnit}
            onSelect={setRecipeUnit}
            loading={false}
          />
        </div>
        <div>
          <div className={styles['label']}>Recipe Quantity</div>
          <WholeNumberInput
            value={recipeQuantity}
            onChange={setRecipeQuantity}
            disabled={false}
          />
        </div>
        <div>
          <div className={styles['label']}>Produce Quantity</div>
          <WholeNumberInput
            value={produceQuantity}
            onChange={setProduceQuantity}
            disabled={false}
          />
        </div>
        <div className={styles['checkbox-group']}>
          <div className={styles['label']}>Main Ingredient</div>
          <input
            type={'checkbox'}
            className={'form-control'}
            checked={isMainIngredient}
            onChange={e => setIsMainIngredient(e.target.checked)}
          />
        </div>
        <div>
          <DropDown title="Cutting Type" value={cuttingType} onChange={setCuttingType} options={CUTTING_TYPE} />
        </div>
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit} className={styles['main-container']}>
      <div className={styles['modal-container']}>
        {getHeader()}
        {getBody()}
        {getFooter()}
      </div>
    </form>
  );
};

export default AddInventoryItemToRecipe;